import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import * as images from "./images";
var styledImages = Object.keys(images).reduce(function (acc, name) {
    var Icon = images[name];
    var StyledImage = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    flex-shrink: 0;\n  "], ["\n    display: block;\n    flex-shrink: 0;\n  "])));
    acc[name] = StyledImage;
    return acc;
}, {});
export var ImageIcon = forwardRef(function (_a, ref) {
    var image = _a.image, rest = __rest(_a, ["image"]);
    var ImageCmp = styledImages[image];
    return _jsx(ImageCmp, __assign({ title: image }, rest, { ref: ref }));
});
var templateObject_1;
